import React from 'react';
import SetupAccountForm from '../Forms/SetupAccountForm';

class SetupAccountPage extends React.Component {
    render = () => (
        <div className="login-background d-flex no-block justify-content-center align-items-center">
            <SetupAccountForm className="bg-white p-4" token={this.props.match.params.resetToken} />
        </div>
    );
}

export default SetupAccountPage;
